import { data } from '../../svg/MoreHorizCircle/data';
import { makeIcon } from '../makeIcon';

export const MoreHorizCircle = makeIcon(data, 'more_horiz_circle', 'MoreHorizCircle');

export default MoreHorizCircle;
